<template>
  <div class="comp-rightpanel">
    <router-view name="panel"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {}
};
</script>

<style scoped lang="scss">
/* @import url(); 引入css类 */
.comp-rightpanel {
  height: 100%;
  background: #f6f7fb;
  padding-top: 17px;
  border: 0px solid skyblue;
}
</style>
